export const urlTypeMapper: { [key: string]: string } = {
  COMPETITION: 'competition',
  RACE: 'competition', // It's correct
  EVENT: 'event',
  GROUP: 'group'
};

export const POPULAR_LINK_NONE_ICON = 'none';
